module.exports = __webpack_public_path__ + "img/ltkhalloween-3x.9b37797.jpg";